import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../app-config';
import { ITlhexRepository } from './Itlhex.repository';
import { ApiResponse, FrameIDTypeEnum, MountingParameters, PortalPageEnum, RingSize } from './models';


@Injectable({ providedIn: 'root' })
export class TlhexRepository implements ITlhexRepository {

	constructor(private readonly httpClient: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) { }


	getRingSizes(): Observable<ApiResponse<RingSize[]>> {
		return this.httpClient.get<ApiResponse<RingSize[]>>(this.config.domainTlhexAPI + `/api/Products/RingSizes`);
	}

	getUsedFrameIDs(userId: string, patientId: string, caseId: string | null = null): Observable<ApiResponse<FrameIDTypeEnum[]>> {
		let params = new HttpParams().set('userId', userId).set('patientId', patientId);
		if (caseId) params = params.set('caseId', caseId);
		return this.httpClient.get<ApiResponse<FrameIDTypeEnum[]>>(this.config.domainTlhexAPI + `/api/TreatmentPlan/UsedFrameIDs`, { params });
	}

	getMountingParameters(caseId: string, userId: string): Observable<ApiResponse<MountingParameters>> {
		let params = new HttpParams().set('caseId', caseId).set('userId', userId);
		return this.httpClient.get<ApiResponse<MountingParameters>>(this.config.domainTlhexAPI + `/api/TreatmentPlan/MountingParameters`, { params });
	}

	getTreatmentSupportPortalUrl(page: PortalPageEnum, patientId?: string, planId?: string): Observable<ApiResponse<string>> {
		let params = new HttpParams().set('page', page);
		if (patientId) params = params.set('patientId', patientId);
		if (planId) params = params.set('caseId', planId);
		return this.httpClient.get<ApiResponse<string>>(this.config.domainTlhexAPI + `/api/Integration/PrepareTreatmentSupportPortalUrl`, { params });
	}
}
